/* tslint:disable */
/* eslint-disable */
/**
 * Real Estate CRM Web API
 * API endpoints for web application
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ClientBriefDtoPaginatedList } from '../models';
// @ts-ignore
import { ClientDetailDto } from '../models';
// @ts-ignore
import { ClientType } from '../models';
// @ts-ignore
import { CreateClientCommand } from '../models';
// @ts-ignore
import { UpdateClientCommand } from '../models';
/**
 * ClientsApi - axios parameter creator
 * @export
 */
export const ClientsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} clientId 
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdDocumentsFileIdGet: async (clientId: number, fileId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiClientsClientIdDocumentsFileIdGet', 'clientId', clientId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('apiClientsClientIdDocumentsFileIdGet', 'fileId', fileId)
            const localVarPath = `/api/Clients/{clientId}/documents/{fileId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} clientId 
         * @param {number} [clientId2] 
         * @param {string} [documentType] 
         * @param {File} [file] 
         * @param {string} [notes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdDocumentsPost: async (clientId: number, clientId2?: number, documentType?: string, file?: File, notes?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiClientsClientIdDocumentsPost', 'clientId', clientId)
            const localVarPath = `/api/Clients/{clientId}/documents`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (clientId2 !== undefined) { 
                localVarFormParams.append('ClientId', clientId2 as any);
            }
    
            if (documentType !== undefined) { 
                localVarFormParams.append('DocumentType', documentType as any);
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('File', file as any);
            }
    
            if (notes !== undefined) { 
                localVarFormParams.append('Notes', notes as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsDocumentsIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiClientsDocumentsIdDelete', 'id', id)
            const localVarPath = `/api/Clients/documents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchTerm] 
         * @param {ClientType} [type] 
         * @param {number} [projectId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsGet: async (pageNumber?: number, pageSize?: number, searchTerm?: string, type?: ClientType, projectId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Clients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['SearchTerm'] = searchTerm;
            }

            if (type !== undefined) {
                localVarQueryParameter['Type'] = type;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['ProjectId'] = projectId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiClientsIdDelete', 'id', id)
            const localVarPath = `/api/Clients/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiClientsIdGet', 'id', id)
            const localVarPath = `/api/Clients/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateClientCommand} [updateClientCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdPut: async (id: number, updateClientCommand?: UpdateClientCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiClientsIdPut', 'id', id)
            const localVarPath = `/api/Clients/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateClientCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateClientCommand} [createClientCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsPost: async (createClientCommand?: CreateClientCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Clients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createClientCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientsApi - functional programming interface
 * @export
 */
export const ClientsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} clientId 
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsClientIdDocumentsFileIdGet(clientId: number, fileId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsClientIdDocumentsFileIdGet(clientId, fileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} clientId 
         * @param {number} [clientId2] 
         * @param {string} [documentType] 
         * @param {File} [file] 
         * @param {string} [notes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsClientIdDocumentsPost(clientId: number, clientId2?: number, documentType?: string, file?: File, notes?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsClientIdDocumentsPost(clientId, clientId2, documentType, file, notes, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsDocumentsIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsDocumentsIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchTerm] 
         * @param {ClientType} [type] 
         * @param {number} [projectId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsGet(pageNumber?: number, pageSize?: number, searchTerm?: string, type?: ClientType, projectId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientBriefDtoPaginatedList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsGet(pageNumber, pageSize, searchTerm, type, projectId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateClientCommand} [updateClientCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsIdPut(id: number, updateClientCommand?: UpdateClientCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsIdPut(id, updateClientCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateClientCommand} [createClientCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsPost(createClientCommand?: CreateClientCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsPost(createClientCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ClientsApi - factory interface
 * @export
 */
export const ClientsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} clientId 
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdDocumentsFileIdGet(clientId: number, fileId: string, options?: any): AxiosPromise<File> {
            return localVarFp.apiClientsClientIdDocumentsFileIdGet(clientId, fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} clientId 
         * @param {number} [clientId2] 
         * @param {string} [documentType] 
         * @param {File} [file] 
         * @param {string} [notes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdDocumentsPost(clientId: number, clientId2?: number, documentType?: string, file?: File, notes?: string, options?: any): AxiosPromise<string> {
            return localVarFp.apiClientsClientIdDocumentsPost(clientId, clientId2, documentType, file, notes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsDocumentsIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiClientsDocumentsIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchTerm] 
         * @param {ClientType} [type] 
         * @param {number} [projectId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsGet(pageNumber?: number, pageSize?: number, searchTerm?: string, type?: ClientType, projectId?: number, options?: any): AxiosPromise<ClientBriefDtoPaginatedList> {
            return localVarFp.apiClientsGet(pageNumber, pageSize, searchTerm, type, projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiClientsIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdGet(id: number, options?: any): AxiosPromise<ClientDetailDto> {
            return localVarFp.apiClientsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateClientCommand} [updateClientCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsIdPut(id: number, updateClientCommand?: UpdateClientCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiClientsIdPut(id, updateClientCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateClientCommand} [createClientCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsPost(createClientCommand?: CreateClientCommand, options?: any): AxiosPromise<number> {
            return localVarFp.apiClientsPost(createClientCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiClientsClientIdDocumentsFileIdGet operation in ClientsApi.
 * @export
 * @interface ClientsApiApiClientsClientIdDocumentsFileIdGetRequest
 */
export interface ClientsApiApiClientsClientIdDocumentsFileIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientsApiApiClientsClientIdDocumentsFileIdGet
     */
    readonly clientId: number

    /**
     * 
     * @type {string}
     * @memberof ClientsApiApiClientsClientIdDocumentsFileIdGet
     */
    readonly fileId: string
}

/**
 * Request parameters for apiClientsClientIdDocumentsPost operation in ClientsApi.
 * @export
 * @interface ClientsApiApiClientsClientIdDocumentsPostRequest
 */
export interface ClientsApiApiClientsClientIdDocumentsPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientsApiApiClientsClientIdDocumentsPost
     */
    readonly clientId: number

    /**
     * 
     * @type {number}
     * @memberof ClientsApiApiClientsClientIdDocumentsPost
     */
    readonly clientId2?: number

    /**
     * 
     * @type {string}
     * @memberof ClientsApiApiClientsClientIdDocumentsPost
     */
    readonly documentType?: string

    /**
     * 
     * @type {File}
     * @memberof ClientsApiApiClientsClientIdDocumentsPost
     */
    readonly file?: File

    /**
     * 
     * @type {string}
     * @memberof ClientsApiApiClientsClientIdDocumentsPost
     */
    readonly notes?: string
}

/**
 * Request parameters for apiClientsDocumentsIdDelete operation in ClientsApi.
 * @export
 * @interface ClientsApiApiClientsDocumentsIdDeleteRequest
 */
export interface ClientsApiApiClientsDocumentsIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientsApiApiClientsDocumentsIdDelete
     */
    readonly id: string
}

/**
 * Request parameters for apiClientsGet operation in ClientsApi.
 * @export
 * @interface ClientsApiApiClientsGetRequest
 */
export interface ClientsApiApiClientsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientsApiApiClientsGet
     */
    readonly pageNumber?: number

    /**
     * 
     * @type {number}
     * @memberof ClientsApiApiClientsGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof ClientsApiApiClientsGet
     */
    readonly searchTerm?: string

    /**
     * 
     * @type {ClientType}
     * @memberof ClientsApiApiClientsGet
     */
    readonly type?: ClientType

    /**
     * 
     * @type {number}
     * @memberof ClientsApiApiClientsGet
     */
    readonly projectId?: number
}

/**
 * Request parameters for apiClientsIdDelete operation in ClientsApi.
 * @export
 * @interface ClientsApiApiClientsIdDeleteRequest
 */
export interface ClientsApiApiClientsIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientsApiApiClientsIdDelete
     */
    readonly id: number
}

/**
 * Request parameters for apiClientsIdGet operation in ClientsApi.
 * @export
 * @interface ClientsApiApiClientsIdGetRequest
 */
export interface ClientsApiApiClientsIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientsApiApiClientsIdGet
     */
    readonly id: number
}

/**
 * Request parameters for apiClientsIdPut operation in ClientsApi.
 * @export
 * @interface ClientsApiApiClientsIdPutRequest
 */
export interface ClientsApiApiClientsIdPutRequest {
    /**
     * 
     * @type {number}
     * @memberof ClientsApiApiClientsIdPut
     */
    readonly id: number

    /**
     * 
     * @type {UpdateClientCommand}
     * @memberof ClientsApiApiClientsIdPut
     */
    readonly updateClientCommand?: UpdateClientCommand
}

/**
 * Request parameters for apiClientsPost operation in ClientsApi.
 * @export
 * @interface ClientsApiApiClientsPostRequest
 */
export interface ClientsApiApiClientsPostRequest {
    /**
     * 
     * @type {CreateClientCommand}
     * @memberof ClientsApiApiClientsPost
     */
    readonly createClientCommand?: CreateClientCommand
}

/**
 * ClientsApi - object-oriented interface
 * @export
 * @class ClientsApi
 * @extends {BaseAPI}
 */
export class ClientsApi extends BaseAPI {
    /**
     * 
     * @param {ClientsApiApiClientsClientIdDocumentsFileIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApi
     */
    public apiClientsClientIdDocumentsFileIdGet(requestParameters: ClientsApiApiClientsClientIdDocumentsFileIdGetRequest, options?: AxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsClientIdDocumentsFileIdGet(requestParameters.clientId, requestParameters.fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientsApiApiClientsClientIdDocumentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApi
     */
    public apiClientsClientIdDocumentsPost(requestParameters: ClientsApiApiClientsClientIdDocumentsPostRequest, options?: AxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsClientIdDocumentsPost(requestParameters.clientId, requestParameters.clientId2, requestParameters.documentType, requestParameters.file, requestParameters.notes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientsApiApiClientsDocumentsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApi
     */
    public apiClientsDocumentsIdDelete(requestParameters: ClientsApiApiClientsDocumentsIdDeleteRequest, options?: AxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsDocumentsIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientsApiApiClientsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApi
     */
    public apiClientsGet(requestParameters: ClientsApiApiClientsGetRequest = {}, options?: AxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsGet(requestParameters.pageNumber, requestParameters.pageSize, requestParameters.searchTerm, requestParameters.type, requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientsApiApiClientsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApi
     */
    public apiClientsIdDelete(requestParameters: ClientsApiApiClientsIdDeleteRequest, options?: AxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientsApiApiClientsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApi
     */
    public apiClientsIdGet(requestParameters: ClientsApiApiClientsIdGetRequest, options?: AxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientsApiApiClientsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApi
     */
    public apiClientsIdPut(requestParameters: ClientsApiApiClientsIdPutRequest, options?: AxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsIdPut(requestParameters.id, requestParameters.updateClientCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientsApiApiClientsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApi
     */
    public apiClientsPost(requestParameters: ClientsApiApiClientsPostRequest = {}, options?: AxiosRequestConfig) {
        return ClientsApiFp(this.configuration).apiClientsPost(requestParameters.createClientCommand, options).then((request) => request(this.axios, this.basePath));
    }
}
